export default "__VITE_ASSET__03fd3295__"